import { ErrorHandler, Injectable, Injector } from '@angular/core';
import * as StackTrace from 'stacktrace-js';

import { AuthService, HorizonLogger } from '@bayclubs/horizon';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(private injector: Injector) {}

    handleError(error) {
        const loggingService = this.injector.get(HorizonLogger);
        const message = error.message ? error.message : error.toString();
        const identity = this.injector.get(AuthService).userName() ?? '';

        StackTrace.fromError(error).then(stackframes => {
            const stackString = stackframes
                .splice(0, 120)
                .map(function(sf) {
                    return sf.toString();
                })
                .join('\n');
            loggingService.error(message, error, null, { identity, stack: stackString });
        });

        throw error;
    }
}
